export const PLATFORM = {
    SIRIUS: 'sirius',
    XM: 'xm',
    SIRIUSXM: 'siriusxm',
} as const;

export type Platform = (typeof PLATFORM)[keyof typeof PLATFORM];
